// extracted by mini-css-extract-plugin
module.exports = {"emojiButton":"Example-module--emoji-button---ihCG"};